<div>
    <p-button icon="pi pi-tags" id="btnConsultarInfoTramites" (onClick)="showDialog()"
              styleClass="p-button-rounded p-button-secondary"
              [pTooltip]="cantidadTramites+' Trámites solicitados'" severity="info"
              [badge]="cantidadTramites+''"></p-button>

    <p-dialog class="flex-wrap" (onHide)="hiddeDialog()" [header]="title()"
              [(visible)]="visible" [closable]="true" [modal]="true"
              [breakpoints]="{ '960px': '75vw' }" [style]="{ width: '60vw' }" [draggable]="false"
              [resizable]="false" closeIcon="pi pi-times loading-icon-size">
        <ng-template pTemplate="header">
            <div class="inline-flex align-items-center justify-content-center gap-2">
                <i class="pi pi-tags text-blue-500 text-2xl"></i>
                <span class="white-space-nowrap">
                    {{ title() }}
                </span>
            </div>
        </ng-template>
        <app-tramites-por-proyecto [datosCargados]="datosCargados" [loading]="loading"
                                   [tramitesPorProyecto]="tramitesPorProyecto"></app-tramites-por-proyecto>
        <ng-template #loading class="flex align-items-center flex-wrap">
            <div class="flex justify-content-center flex-wrap">
                <p-progressSpinner></p-progressSpinner>
            </div>
        </ng-template>
    </p-dialog>
</div>
